import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import Logo from "./Logo";

const Footer = () => (
  <footer data-testid="footer" className="bg-navy text-slate-300">
    <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12 py-16">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo light className="text-lg" />
          <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-xs">
            Consulting for governance, compliance, and operational
            resilience — built for predictable, sustainable outcomes.
          </p>
        </div>

        <div>
          <h4 className="text-white text-sm font-semibold uppercase tracking-[0.18em] mb-5">
            Navigate
          </h4>
          <ul className="space-y-3 text-sm">
            {[
              { label: "Home", to: "/" },
              { label: "About", to: "/about" },
              { label: "Services", to: "/services" },
              { label: "Our Approach", to: "/approach" },
              { label: "Contact", to: "/contact" },
            ].map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-slate-400 hover:text-gold transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm font-semibold uppercase tracking-[0.18em] mb-5">
            Legal
          </h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/privacy" className="text-slate-400 hover:text-gold transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="text-slate-400 hover:text-gold transition-colors">Terms of Use</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm font-semibold uppercase tracking-[0.18em] mb-5">
            Contact
          </h4>
          <ul className="space-y-4 text-sm text-slate-400">
            <li className="flex items-start gap-3">
              <Mail size={18} className="text-gold mt-0.5 shrink-0" />
              <a href="mailto:ScottWilson@yanacapitalgroup.com" className="hover:text-gold transition-colors break-all">
                ScottWilson@yanacapitalgroup.com
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={18} className="text-gold mt-0.5 shrink-0" />
              <a href="tel:+16193401668" className="hover:text-gold transition-colors">(619) 340-1668</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={18} className="text-gold mt-0.5 shrink-0" />
              <span>1223 Cleveland Ave.<br />San Diego, CA 92103</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-slate-700 flex flex-col sm:flex-row justify-between gap-4 text-xs text-slate-500">
        <p>© {new Date().getFullYear()} Yana Capital Group. All rights reserved.</p>
        <p>Advisory built around structure, stability, and practical value.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
